export type DVariantKey = "d1" | "d2" | "d3" | "d4" | "d5" | "d6";

export type Palette = { gradStart: string; gradEnd: string; accent: string };

export const palettes: Record<DVariantKey, { light: Palette; dark: Palette }> = {
  d1: {
    light: { gradStart: "hsl(160 70% 45%)", gradEnd: "hsl(185 75% 42%)", accent: "hsl(150 85% 70%)" },
    dark:  { gradStart: "hsl(160 55% 22%)", gradEnd: "hsl(185 55% 22%)", accent: "hsl(150 70% 55%)" },
  },
  d2: {
    light: { gradStart: "hsl(270 70% 58%)", gradEnd: "hsl(320 75% 58%)", accent: "hsl(295 90% 75%)" },
    dark:  { gradStart: "hsl(270 55% 30%)", gradEnd: "hsl(320 55% 30%)", accent: "hsl(295 80% 65%)" },
  },
  d3: {
    light: { gradStart: "hsl(85 75% 50%)", gradEnd: "hsl(155 70% 45%)", accent: "hsl(110 85% 70%)" },
    dark:  { gradStart: "hsl(85 55% 26%)", gradEnd: "hsl(155 55% 24%)", accent: "hsl(110 70% 55%)" },
  },
  d4: {
    light: { gradStart: "hsl(40 95% 58%)", gradEnd: "hsl(20 90% 55%)", accent: "hsl(45 100% 72%)" },
    dark:  { gradStart: "hsl(40 75% 32%)", gradEnd: "hsl(20 70% 30%)", accent: "hsl(45 90% 60%)" },
  },
  d5: {
    light: { gradStart: "hsl(205 85% 58%)", gradEnd: "hsl(245 75% 58%)", accent: "hsl(220 90% 75%)" },
    dark:  { gradStart: "hsl(205 60% 28%)", gradEnd: "hsl(245 55% 30%)", accent: "hsl(220 75% 65%)" },
  },
  d6: {
    light: { gradStart: "hsl(345 80% 60%)", gradEnd: "hsl(20 90% 58%)", accent: "hsl(5 95% 72%)" },
    dark:  { gradStart: "hsl(345 60% 32%)", gradEnd: "hsl(20 65% 32%)", accent: "hsl(5 80% 60%)" },
  },
};

export const slugToVariant: Record<string, DVariantKey> = {
  "founder-financial-modeling": "d1",
  "financial-modeling-kit": "d1",
  "free-pitch-template": "d2",
  "pitch-template": "d2",
  "free-founder-checklist": "d3",
  "founder-checklist": "d3",
  "lean-validation-playbook": "d4",
  "notion-template": "d5",
  "ops-template": "d5",
  "emerging-markets-gtm": "d6",
  "gtm-guide": "d6",
  "ai-operations-leaders": "d5",
  "b2b-acquisition-linkedin": "d2",
  "cash-pricing-profit-founders": "d1",
  "finance-growth-no-dilution": "d6",
  "premium-francophone-solopreneur": "d4",
};

export function djb2(str: string): number {
  let h = 5381;
  for (let i = 0; i < str.length; i++) h = ((h << 5) + h + str.charCodeAt(i)) >>> 0;
  return h;
}

const ORDER: DVariantKey[] = ["d1", "d2", "d3", "d4", "d5", "d6"];

export function resolveVariant(slug: string): DVariantKey {
  return slugToVariant[slug] ?? ORDER[djb2(slug) % 6];
}
